var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14.6552,
    cy: 14.6552,
    r: 14.6552,
    fill: "#2F3032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0716 14.6552C28.0716 22.065 22.0648 28.0718 14.6549 28.0718C7.24513 28.0718 1.23828 22.065 1.23828 14.6552C1.23828 7.24534 7.24513 1.23849 14.6549 1.23849C22.0648 1.23849 28.0716 7.24534 28.0716 14.6552Z",
    stroke: "#E5E5E5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8634 11.1135C18.8634 13.4377 16.9793 15.3218 14.6551 15.3218C12.3309 15.3218 10.4468 13.4377 10.4468 11.1135C10.4468 8.78932 12.3309 6.90518 14.6551 6.90518C16.9793 6.90518 18.8634 8.78932 18.8634 11.1135Z",
    stroke: "#E5E5E5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_50_652",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.03027 23.8635L8.28027 19.6135L14.6553 21.7385L21.0303 19.6135L25.2803 23.8635"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.28027 19.6135L8.75461 18.1905L7.87514 17.8973L7.21961 18.5528L8.28027 19.6135ZM14.6553 21.7385L14.1809 23.1615L14.6553 23.3196L15.1296 23.1615L14.6553 21.7385ZM21.0303 19.6135L22.0909 18.5528L21.4354 17.8973L20.5559 18.1905L21.0303 19.6135ZM5.09093 24.9242L9.34093 20.6742L7.21961 18.5528L2.96961 22.8028L5.09093 24.9242ZM7.80593 21.0365L14.1809 23.1615L15.1296 20.3155L8.75461 18.1905L7.80593 21.0365ZM15.1296 23.1615L21.5046 21.0365L20.5559 18.1905L14.1809 20.3155L15.1296 23.1615ZM19.9696 20.6742L24.2196 24.9242L26.3409 22.8028L22.0909 18.5528L19.9696 20.6742Z",
    fill: "#E5E5E5",
    mask: "url(#path-4-inside-1_50_652)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/loginIcon.59488655ed1253546dc911f13bcec3a9.svg";
export { ForwardRef as ReactComponent };